// Copyright (c) 2017 Deere & Company

import {
    isNotEmpty,
    isNotNull
} from '../../../claim/shared/services/claim-shared-helper';
import actions from '../../actions-list';

export const validateOtherUseAmount = (value, registration) => [
    isNotNull(registration.otherUseAmount.amount),
    isNotEmpty(registration.otherUseAmount.unit.key)
].every(rule => rule);

export const validateUseAmount = (value, registration) => [
    isNotNull(registration.useAmount.amount),
    isNotEmpty(registration.useAmount.unit.key)
].every(rule => rule);

const mapFormValidation = (property, value, registration) => {

    const map = {
        deliveryDate: isNotNull,
        endUseCode: isNotEmpty,
        otherUseAmount: validateOtherUseAmount,
        pin: isNotEmpty,
        purchaserType: isNotEmpty,
        registrationStatus: isNotEmpty,
        responsibleDealer: isNotEmpty,
        useAmount: validateUseAmount
    };

    return map[property](value, registration);

};

export const updateFormValidation = (property, value, registration) =>

    dispatch =>

        dispatch({
            property,
            type: actions.UPDATE_PRODUCT_REGISTRATION_FORM_VALIDATION,
            validity: mapFormValidation(property, value, registration)
        });

export const resetFormValidation = () => ({
    type: actions.RESET_PRODUCT_REGISTRATION_FORM_VALIDATION
});



// WEBPACK FOOTER //
// ./src/product/product-registration/action-creators/form-validation.js